import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const MaterialRequestsPage = lazy(
  () => import('@/containers/Views/Events/MaterialRequests/MaterialRequestsPage'),
);

const MaterialRequestsRouter = (
  <Route path="events">
    <Route
      path="material_requests"
      element={(
        <PrivateRoute
          pageName={EPage.MaterialRequests}
          permissions={EBasicActions.Find}
        >
          <MaterialRequestsPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default MaterialRequestsRouter;
